module.exports = __webpack_public_path__ + "static/img/qi_6.fa67f5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qi_6.jpg
// module id = bHu7
// module chunks = 1